export default function CardLoading() {
    return (<div className="card-loading-container">
        <div className="loader"/>
    </div>)
}